import React from 'react';
import './SubmissionAttachmentSubClassification.css';
import { AttachmentStatus } from '../../../../services/constants/constants';
import CustomizedTooltip from '../../../atoms/Tooltip/CustomizedTooltip';

const SubmissionAttachmentSubClassification = (props) => {

  const { classification, subClassification, subClassificationTypes, status, editMode } = props;
  const { handleClassificationSubTypeChange } = props;
  const [value1, setValue1] = React.useState(subClassification);

  const classificationSubTypeChanged = (value) => {
    setValue1(value);
    handleClassificationSubTypeChange(value);
  }

  const hasSubClassification = () => {
    return subClassificationTypes.some(
      (x) => x.key.toUpperCase() === classification?.toUpperCase()
    );
  }

  const getSubClassificationType = () => {
    if (subClassification) {
      const value = subClassificationTypes.find(
        (x) => x.value.toUpperCase() === subClassification?.toUpperCase()
      )?.value;

      return value ? value : subClassification;
    }

    return '';
  }

  return (
    <React.Fragment>
      {/* {editMode && hasSubClassification() ?
        <Dropdown optionLabel='value' optionValue='value' value={value1}
          options={subClassificationTypes} onChange={(e) => classificationSubTypeChanged(e.value)}
          placeholder='Select a sub classification' />
        : */}
      <React.Fragment>
        {status !== AttachmentStatus.Received &&
          <React.Fragment>
            <CustomizedTooltip text={getSubClassificationType()}>
              <span className='truncate label-truncate scl-ptooltip'>
                {getSubClassificationType()}
              </span>
            </CustomizedTooltip>
          </React.Fragment>
        }
      </React.Fragment>
    </React.Fragment >
  )
}

export default React.memo(SubmissionAttachmentSubClassification);
